 <template lang="pug">
  v-stepper(v-model="e1" style="margin-top:1px")
    v-stepper-header
        v-stepper-step(:complete="e1 > 1" step="1") Detail Usulan
        v-divider
        v-stepper-step(:complete="e1 > 2" step="2") Klasifikasi & Rincian
        v-divider
        v-stepper-step(:complete="e1 > 3" step="3") Latar Belakang
        v-divider
        v-stepper-step(:complete="e1 > 4" step="4") Penilaian Risiko
        v-divider
        v-stepper-step(:complete="e1 > 5" step="5") Daftar Periksa
    
    v-stepper-items
      v-stepper-content(step="1")
        DetailUsulan(:e1="e1" @continueBtn ="updateNumberStep" :dataSubmitPerubahan="dataSubmitPerubahan")
        
      v-stepper-content(step="2")
          KlasifikasiRincian(:e1="e1" @continueBtn ="updateNumberStep" :dataSubmitPerubahan="dataSubmitPerubahan")
      
      v-stepper-content(step="3")
          LatarBelakang(:e1="e1" @continueBtn ="updateNumberStep" :dataSubmitPerubahan="dataSubmitPerubahan")
      
      v-stepper-content(step="4")
          PenilaianResiko(:e1="e1" @continueBtn ="updateNumberStep" :dataSubmitPerubahan="dataSubmitPerubahan" )

      v-stepper-content(step="5")
          DaftarPeriksa(:e1="e1" @continueBtn ="updateNumberStep" :dataSubmitPerubahan="dataSubmitPerubahan" :edit="isEdit")
</template>

<script>
import { mapState } from "vuex";
import DetailUsulan from "./usulan-perubahan/DetailUsulan.vue";
import KlasifikasiRincian from "./usulan-perubahan/KlasifikasiRincian.vue";
import LatarBelakang from "./usulan-perubahan/LatarBelakang.vue";
import PenilaianResiko from "./usulan-perubahan/PenilaianResiko.vue";
import DaftarPeriksa from "./usulan-perubahan/DaftarPeriksa.vue";
import helper from "../helper/index.js";
export default {
  name: "AddUsulanPerubahan",
  components: {
    DetailUsulan,
    KlasifikasiRincian,
    LatarBelakang,
    PenilaianResiko,
    DaftarPeriksa
  },
  props: [""],
  data() {
    return {
      e1: 1,
      dataSubmitPerubahan :{
        ipJudulPekerjaan:"",
        ipTanggalPerubahan:"",
        ipPemegangIzin:{},
        ipDeptDivisi:"",
        ipDivisi:"",
        ipPerusahaan:"",
        ipJabatan:"",
        ipKlasifikasiUmum:[],
        ipRincianUsulan:[],
        ipHasilHarapan:[],
        ipHasilDescription:"",
        ipHasilDescriptionUploadId:"",
        ipHasilDescriptionLampiran:{},
        ipLocation:[],
        ipLatarBelakang:"",
        ipLatarBelakangUploadId:"",
        ipLatarBelakangLampiran:{},
        ipPerubahanDiusulkan:"",
        ipPerubahanDiusulkanUploadId:"",
        ipPerubahanDiusulkanLampiran:{},
        ipTindakanPengendalian:[],

        ipTingkatRisikoAwal:{
          nilaiKonsekuensi : null,
          kekerapan:null,
          tingkatRisiko:null
        },
        ipTingkatRisikoSetelahPerubahan:{
          nilaiKonsekuensi : null,
          kekerapan:null,
          tingkatRisiko:null
        },
        ipPerluPerubahan:{
          selected :"",
          description:""
        },
        ipMempengaruhiGaransi:{
          selected :"",
          description:""
        },
        ipMempengaruhiSpek:{
          selected :"",
          description:""
        },
        ipPerluUpdate:{
          selected :"",
          description:""
        },
        ipMengurangiStok:{
          selected :"",
          description:""
        },
        ipStokBaru:{
          selected :"",
          description:""
        },
        ipBahanKimia:{
          selected :"",
          description:""
        },
        ipPersetujuanPabrik:{
          selected :"",
          description:""
        },
        ipBerdampakLain:{
          selected :"",
          description:""
        },
      },
      isEdit: false
    };
  },
  mounted() {
    this.dataSubmitPerubahan.ipUser = this.dataUsers
    this.dataSubmitPerubahan.ipPemegangIzin = this.dataUsers
    this.dataSubmitPerubahan.ipLocation = this.selectedLoc
  },
  computed: {
    ...mapState(["API_URL","locations","dataUsers","dataEditRequest"]),
    selectedLoc() {
      let tempLoc = [];
      for (let i = 0; i < this.dataUsers.location.length; i++) {
        tempLoc.push({ code: this.dataUsers.location[i], name: "" });
      }
      return tempLoc;
    }
  },
  methods: {
    updateNumberStep(val){
        this.e1 = val
    },
    getWITADate: helper.getWITADate
  },
  watch: {
    dataEditRequest: function() {
      for (let prop in this.dataEditRequest) {
        if ( !(prop in this.dataSubmitPerubahan) && prop != "ipNo" ) {
          delete this.dataEditRequest[prop];
        }
      }
      
      this.dataEditRequest.ipTanggalPerubahan = this.getWITADate(this.dataEditRequest.ipTanggalPerubahan)

      this.dataSubmitPerubahan = this.dataEditRequest
      this.isEdit = true
    },
  },
};
</script>

<style></style>
